<template>
  <div class="my-breadcrumb" style="box-shadow: rgb(177 194 223) 1px 2px 0px 0px !important;" align-h="center">
    <div class="breadcrumb-title align-items-center d-flex ml-5">
      <b-link @click="goBack">
        <font-awesome-icon :icon="['far', 'chevron-left']" size="lg" />
        <span class="pl-2">Atrás</span>
      </b-link>

      <b-link
        :to=" `/app/prod/clientes/${submital.client_id}`"
        :disabled="!submital.client_id"
        class="breadcrumb-link ml-5"
      >
        <font-awesome-icon :icon="['far', 'address-book']" size="lg" fixed-width />
        <span v-if="submital.client">{{ submital.client.client_num }}</span>
        <span v-else>CL00000</span>
      </b-link>
      <font-awesome-icon :icon="['far', 'chevron-right']" pull="right"/>
      <b-link
        :to="`/app/prod/proyectos/${submital.project_id}`"
        :disabled="!submital.project_id"
        class="breadcrumb-link"
      >
        <font-awesome-icon :icon="['far', 'briefcase']" size="lg" fixed-width />
      </b-link>
      <font-awesome-icon :icon="['far', 'chevron-right']" pull="right"/>
      <span class="breadcrumb-inactive">{{ submital.submital_no }}</span>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  export default {
    name: 'submitalNavbar',
    computed: {
      ...mapState({
        submital: state => state.configurator.submital
      }),
      ...mapGetters (['configurableRouteSlugify'])
    },
    methods: {
      goBack () {
        if (!this.configurableRouteSlugify) return

        this.$router.push({ name: 'SubmitalIndex', params: { configurable_type: this.configurableRouteSlugify } })
      }
    }
  }
</script>